module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAIBJREFUOE9jZKASYASZoxh00O8/47+ZIDbjf6b0++vsNyGLMzIwSmCz7z/D/xcw9WCDFIL3P4cp/s/A8OLBWgdJdHFcDoepp7JBIfv8Gf4zzQDbyvgv48Eap41gF0HFGRkYcHiN4QVMPdhF1ADUNWg01jDiBJSGRmMNkQdHcF4DAGbrsRNnWfH1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common.png
// module id = 126
// module chunks = 0